import RESTService from './RESTService';
import jwtDecode from 'jwt-decode';
import StorageService from './StorageService';

const connect = new RESTService();
const SS = new StorageService();
let instance = null;

export default class AuthService {
	// On bootstrap, check if user have a token in Local Storage
	constructor() {
		if (!instance) {
			instance = this;
		}
		this.TOKEN_NAMESPACE = process.env.REACT_APP_TOKEN_NAMESPACE;
		const token = window.localStorage.getItem(this.TOKEN_NAMESPACE);
		if (token) {
			this.storeAccessToken(token);
		}
		return instance;
	}

	storeAccessToken(token) {
		try {
			this.decodedToken = jwtDecode(token);
			SS.setUserData('userInfo', this.decodedToken);
			this.token = token;
			connect.setAuthorizationToken(token);
			if (this.decodedToken.email) {
				let mix = window.mixpanel;
				mix.identify(this.decodedToken.email);
				mix.people.set({
					$email: this.decodedToken.email,
					$last_login: new Date(),
					$name: this.decodedToken.name
				});
			}
		} catch (e) {
			//TODO's use the new error object
			console.error('Invalid token format.', e.message);
		}
		return window.localStorage.setItem(this.TOKEN_NAMESPACE, token);
	}

	logout() {
		window.localStorage.removeItem(this.TOKEN_NAMESPACE);
		SS.setUserData('userInfo', null);
		this.decodedToken = null;
		this.token = null;
		window.location = '/login';
	}

	isAuthenticated() {
		if (this.token) {
			let now = new Date();
			let decodedToken = jwtDecode(this.token);
			if (decodedToken.exp * 1000 < now.getTime()) {
				return false;
			}
		}
		return !!this.token;
	}

	getTenantRoles() {
		if (!this.decodedToken) {
			return null;
		}
		return this.decodedToken.tenantRoles;
	}

	getRole() {
		//TODO get role based on platform or current tenant
		if (!this.decodedToken) {
			return '';
		}
		if (!this.decodedToken.platformRoles) {
			return 'tenant-admin';
		}
		return this.decodedToken.platformRoles;
	}

	isPlatformManager() {
		return this.getRole() === 'platform-manager';
	}

	isPlatformAdmin() {
		return this.getRole() === 'platform-admin';
	}

	hasPlatformRole() {
		return this.isPlatformAdmin() || this.isPlatformManager();
	}

	isAnyAdmin() {
		return this.hasPlatformRole() || this.getRole().indexOf('admin') >= 0;
	}

	getAvailableTenants() {
		if (!this.decodedToken || this.decodedToken.platformRoles || !this.decodedToken.tenantRoles) {
			return [];
		}
		return Object.keys(this.decodedToken.tenantRoles);
	}
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js